<template>
  <div style="overflow-x: auto; width: auto; min-height: 95vw">
    <CCol v-if="messages.length" sm="12">
      <transition name="fade">
        <MenssageAlert :messages="messages" />
      </transition>
    </CCol>
    <nav
      class="nav d-flex"
      :class="campaign.values.length > 3 ? '' : 'justify-content-center'"
      :style="campaign.values.length > 3 ? 'width:2000px;' : ''"
      id="flow-js"
    >
      <!--REMOVIDO justify-content-center maior que 3 remove center e add width:2000px; flowWidth-->
      <ul>
        <template>
          <li>
            <center>
              <CSpinner v-if="loadingRocket" class="c-spinner" color="custom-color" style="width: 1.1rem; height: 1.1rem" />
              <!-- <div v-else :class="rocketControl.className" @click="rocketControlStatus(campaignStatus)">
                <CIcon class="text-primary" style="margin-top: 14px" :name="rocketControl.iconName" :height="45" viewBox="0 0 32 32" />
                <span :class="rocketControl.classText" class="text-uppercase">{{ rocketControl.text }}</span>
              </div> -->
              <CButton
                v-else
                color="primary"
                class="px-5 py-2 border"
                :disabled="campaign.status != 'READY_TO_SEND' && campaign.status != 'RUN'"
                @click="rocketControlStatus(campaignStatus)"
              >
                {{ rocketControl.text }}
              </CButton>
            </center>
            <br />
            <div v-if="campaign.status == 'SETUP'" @click="cancelCreateCampaign()" style="font-weight: normal; font-size: 11px; color: #a1a8b3">
              <i class="fa fa-chevron-left" aria-hidden="true"></i>
              {{ $t('campaign.campaignCreator.flow.text.cancel') }}
            </div>
            <div v-if="campaign.status == 'RUN'" @click="cancelCreateCampaign()" style="font-weight: normal; font-size: 11px; color: #a1a8b3">
              <i class="fa fa-chevron-left" aria-hidden="true"></i>
              {{ $t('campaign.campaignCreator.flow.text.cancel') }}
            </div>
            <div
              v-if="campaignStatusLabel == 'READY_TO_SEND' && campaignStatus == 3"
              @click="backToRun()"
              style="font-weight: normal; font-size: 11px; color: #a1a8b3"
            >
              <i class="fa fa-chevron-left" aria-hidden="true"></i>

              {{ $t('campaign.campaignCreator.flow.text.back-to-ruk') }}
            </div>
            <div v-if="campaignStatus == 6" @click="backToCampaign()" style="font-weight: normal; font-size: 11px; color: #a1a8b3">
              <i class="fa fa-chevron-left" aria-hidden="true"></i>

              {{ $t('campaign.campaignCreator.flow.text.back-to-campaign') }}
            </div>

            <ul :style="campaign.status == 'READY_TO_SEND' ? 'pointer-events: none; cursor: none;' : ''">
              <li
                v-for="(item, indexChannel) in campaign.values"
                :key="indexChannel"
                class="mx-3 flowComponentMain__item"
                :class="{
                  'flowComponentMain__item--active': indexChannel == indexChannelActive ? true : false,
                }"
              >
                <div style="mainBox">
                  <a class="flowComponentClose text-uppercase" v-if="campaign.values.length !== 1" @click.prevent="removeChannel(indexChannel)"></a>
                  <div style class="headMainBox text-uppercase">{{ $t('campaign.campaignCreator.flow.text.channelTitle') }}</div>
                  <div class="bodyMainBox text-uppercase" :style="campaign.status == 'READY_TO_SEND' ? 'background-color: #e5e5e5;' : ''">
                    <CIcon :name="channelType[item.channel].toLowerCase()" :height="25" viewBox="0 0 32 32" />
                    <span class="ml-2">{{ $t(`campaign.campaignCreator.flow.text.channel.${channelType[item.channel].toLowerCase()}`) }}</span>
                  </div>
                </div>

                <template v-for="(prop, i) in item">
                  <span
                    v-if="i != 'schedulingId'"
                    @click="pushChannel(indexChannel, i, channelType[item.channel])"
                    :key="channelType[item.channel] + i"
                  >
                    <FlowCard
                      @click="scrollTop(null)"
                      v-if="isCard(prop) && i !== 'conditions'"
                      :icon="i"
                      :attr="attrByType(i)"
                      :isSelected="isCardClicked(i, indexChannel, activeBlock.indexChannel)"
                      :status="campaign.status"
                    >
                      <template v-slot:title>{{ $t(`campaign.campaignCreator.flow.card.type.${i.toLowerCase()}`) }}</template>

                      <template v-slot:body>
                        <template v-if="i === 'audience'">
                          <div v-if="!prop.targetAudienceType">
                            <p class="pb-3 mb-3 boxCreatorTitle text-uppshipping-timeercase" style>
                              <CIcon style="margin-top: -3px" class="ml-2 mr-1" name="allAudience" :height="30" viewBox="0 0 32 32" />
                            </p>
                            <p class="text-box-campaign">
                              {{ $t('campaign.campaignCreator.flow.card-text.audience.select-your-audience') }}
                            </p>
                          </div>
                          <p v-if="prop.targetAudienceType" class="pb-3 mb-3 boxCreatorTitle text-uppercase" style>
                            <CIcon style="margin-top: -3px" class="ml-2 mr-1" :name="prop.targetAudienceType" :height="30" viewBox="0 0 32 32" />
                            {{ $t(`campaign.campaignCreator.flow.targetAudienceType.${prop.targetAudienceType}`) }}
                          </p>

                          <div style="min-height: 90px; overflow: hidden">
                            <span
                              v-for="(segments, IndexAudience) in prop.segments"
                              :key="IndexAudience + 'audi'"
                              class="mt-1 m-1 p-lg-2 badge badge-primary bg-audience"
                              >{{ segments.name }}</span
                            >
                          </div>
                        </template>

                        <template v-if="i === 'time'">
                          <div v-if="!prop.targetTimeType">
                            <p class="pb-3 mb-3 boxCreatorTitle text-uppercase" style>
                              <CIcon style="margin-top: -3px" class="ml-2 mr-1" name="time" :height="30" viewBox="0 0 32 32" />
                            </p>
                            <p class="text-box-campaign">
                              {{ $t('campaign.campaignCreator.flow.text.time-your-campaign') }}
                            </p>
                          </div>
                          <p v-if="prop.targetTimeType" class="pb-3 mb-3 boxCreatorTitle text-uppercase" style>
                            <CIcon style="margin-top: -3px" class="ml-2 mr-1" :name="prop.targetTimeType" :height="30" viewBox="0 0 32 32" />
                            {{ $t(`campaign.campaignCreator.flow.targetAudienceType.${prop.targetTimeType}`) }}
                          </p>
                          <div v-if="prop.targetTimeType == 'sendNow'" class="pb-3">
                            <p class="text-box-campaign text-uppercase">
                              {{ $t('campaign.campaignCreator.flow.text.shipping-date') }}
                              <br />
                              {{
                                prop.targetTimeType == 'sendNow' ? $t('campaign.creator.flow.text.sendNow') : formatDate(prop.date, { zone: 'utc' })
                              }}
                            </p>
                          </div>

                          <div v-if="prop.targetTimeType == 'schedule'" style="text-align: center" class="text-box-campaign">
                            <p class="text-uppercase">
                              {{ $t('campaign.campaignCreator.flow.text.shipping-date') }}
                              <br />
                            </p>
                            {{ formatDate(prop.scheduleDate, { zone: 'utc' }) }}
                            <p v-if="prop.isWorkingDays" class="text-uppercase">
                              {{ $t('campaign.campaignCreator.flow.text.dont-weekends') }}
                            </p>

                            <p class="text-uppercase mt-3" v-if="prop.scheduleTime !== '00:00'">
                              <span>
                                {{ $t('campaign.campaignCreator.flow.text.shipping-time') }}
                              </span>
                              <br />
                              <img src="img/site/relogio.png" class="relogioTime" />
                              {{ prop.scheduleTime }}
                            </p>
                            <div v-if="channelType[item.channel] == 'SMS'">
                              <p class="text-uppercase mt-3">
                                <span> {{ $t('campaign.campaignCreator.flow.text.start-time') }}</span>
                                <br />
                                <img src="img/site/relogio.png" class="relogioTime" />
                                {{ prop.beginTime }}
                              </p>
                              <p class="text-uppercase mt-3">
                                <span> {{ $t('campaign.campaignCreator.flow.text.end-time') }}</span>
                                <br />
                                <img src="img/site/relogio.png" class="relogioTime" />
                                {{ prop.endTime }}
                              </p>
                            </div>
                          </div>
                          <img v-if="prop.targetTimeType && prop.targetTimeType == 'sendNow'" src="img/site/relogio.png" class="relogioTime" />
                          <div
                            v-if="campaign.status == 'READY_TO_SEND' && campaignSummary != null"
                            class="col-md-12 mt-3 p-2"
                            style="background-color: #fff; position: absolute; left: 0px"
                          >
                            <CIcon
                              style="margin-top: -3px; color: #7f889a"
                              class="ml-2 mr-1 mt-2 mb-1"
                              name="sms"
                              :height="25"
                              viewBox="0 0 32 32"
                              v-if="channelType[item.channel] == 'SMS'"
                            />
                            <CIcon
                              style="margin-top: -3px; color: #7f889a"
                              class="ml-2 mr-1 mt-2 mb-1"
                              name="email"
                              :height="25"
                              viewBox="0 0 32 32"
                              v-if="channelType[item.channel] == 'EMAIL'"
                            />
                            <p v-if="channelType[item.channel] == 'SMS'" style="color: #22252b; font-size: 18px">
                              {{ campaignSummary.schedulingSummaries[indexChannel].totalSMSCount }}
                            </p>
                            <p v-if="channelType[item.channel] == 'EMAIL'" style="color: #22252b; font-size: 18px">
                              {{ campaignSummary.schedulingSummaries[indexChannel].totalEmailCount }}
                            </p>
                            <p style="color: #a1a8b3; font-size: 15px">NUMBER OF {{ channelType[item.channel] }}'S</p>
                          </div>
                        </template>

                        <template v-if="i === 'content'">
                          <div v-if="channelType[item.channel] == 'EMAIL'" class="text-box-campaign font-base">
                            <p class="pb-3 mb-3 boxCreatorTitle text-uppercase" style>
                              <CIcon style="margin-top: -3px" class="ml-2 mr-1" name="changeEmail" :height="33" viewBox="0 0 32 32" />
                            </p>
                            <template v-if="i === 'content' && prop.templateId">
                              <!-- 1 = simples text || 2 = html -->
                              <imageTemplate
                                v-if="prop.contentType == 2"
                                :template="prop"
                                :view="true"
                                :dynamicDestinationType="DYNAMIC_TEMPLATE_DESTINATION_TYPE.CAMPAIGN"
                              />
                              <textSimple v-else :template="prop" :view="true" />
                              <!-- {{ prop }} -->
                              <div>
                                <p class="text-box-campaign text-uppercase mt-2">{{ $t('campaign.creator.flow.label.subject') }}</p>
                                {{ prop.subject }}
                              </div>
                              <div>
                                <p class="text-box-campaign text-uppercase mt-2">
                                  {{ $t('campaign.creator.flow.label.from') }}
                                </p>
                                {{ prop.displayName }}
                              </div>
                              <!-- <div>
                                <p class="text-box-campaign text-uppercase mt-2">EmailPrefix</p>
                                {{ prop.emailPrefix }}
                              </div> -->
                              <div>
                                <p class="text-box-campaign text-uppercase mt-2">{{ $t('campaign.creator.flow.label.sender') }}</p>
                                {{ prop.from }}
                              </div>
                              <div>
                                <p class="text-box-campaign text-uppercase mt-2">{{ $t('campaign.creator.flow.label.reply') }}</p>
                                {{ prop.replyTo }}
                              </div>
                            </template>
                            <template v-if="i === 'content' && !prop.templateId">
                              <!--<img src="img/emailTemplate.png" class="emailTemplate" />-->
                              <p>
                                {{ $t('campaign.campaignCreator.flow.text.choose-content-email') }}
                              </p>
                            </template>
                          </div>
                          <div v-else-if="channelType[item.channel] == 'SMS'">
                            <template v-if="prop.templateId || prop.content">
                              <p class="pb-3 mb-3 boxCreatorTitle text-uppercase" style>
                                <CIcon
                                  style="margin-top: -3px"
                                  class="ml-2 mr-1"
                                  :name="prop.isNewContent ? 'newSms' : 'smsTemplate'"
                                  :height="33"
                                  viewBox="0 0 32 32"
                                />

                                {{ $t(`campaign.campaignCreator.flow.targetAudienceType.${prop.isNewContent ? 'newSms' : 'smsTemplate'}`) }}
                              </p>
                              <!--{{prop}}-->
                              <span class="text-box-campaign">
                                {{ prop.content }}
                              </span>
                              <br />
                            </template>
                            <template v-if="!prop.templateId && !prop.content">
                              <p class="pb-3 mb-3 boxCreatorTitle text-uppercase" style>
                                <CIcon style="margin-top: -3px" class="ml-2 mr-1" name="contentTemplate" :height="35" viewBox="0 0 32 32" />
                              </p>
                              <p class="text-box-campaign font-base">
                                {{ $t('campaign.campaignCreator.flow.text.choose-content-sms') }}
                              </p>
                            </template>
                          </div>
                          <button
                            v-if="(prop.content || prop.templateId) && campaign.status != 'READY_TO_SEND' && !isPlanFree"
                            @click="openContentTest(indexChannel)"
                            class="btn btn-primary btnSendTest mt-3 text-uppercase"
                            :disabled="channelType[item.channel] == 'SMS' ? !prop.senderId : !prop.senderId || prop.emailPrefix.length == 0"
                          >
                            {{ $t('campaign.campaignCreator.flow.text.send-a-test') }}
                          </button>
                          <transition name="fade" v-if="isTestSent[indexChannel]">
                            <span style="display: block" class="text-box-campaign font-base mt-2">{{ isTestSentMessage }}</span>
                          </transition>
                          <transition name="fade" v-if="contentTest[indexChannel] && activeBlock.indexChannel == indexChannel">
                            <div
                              class="dataTable__popUp popUp"
                              style="width: 280px; position: fixed; top: 50%; left: 50%; transform: translateX(-50%)"
                            >
                              <div class="popUp__body shadow-sm" style="padding: 20px 20px">
                                <div class="confirmationDelete">
                                  <div class="confirmationDelete__header">
                                    <p style="font-size: 18px; color: #22252b" class="confirmationDelete__title font-weight-semi-bold mb-1">
                                      {{ $t('campaign.campaignCreator.flow.text.test-send-contact') }}
                                    </p>
                                  </div>
                                  <div class="confirmationDelete__body mb-4">
                                    <CRow v-if="channelType[item.channel] == 'SMS'" sm="12" class="d-flex mt-3" :gutters="false">
                                      <CCol sm="5" class="mr-1 ml-1" style="border: 1px solid #e5e5e5">
                                        <v-select
                                          class="mb-0 no-close select-country-code"
                                          :options="optionsCountries"
                                          v-model="countrySelected"
                                          id="countrySelected"
                                          placeholder=""
                                        >
                                          <template #selected-option="{ label, flag }">
                                            <div class="d-flex align-items-center">
                                              <img :src="flag" alt width="25" />
                                              <span class="ml-2">
                                                {{ label }}
                                              </span>
                                            </div>
                                          </template>
                                          <template v-slot:option="option">
                                            <img :src="option.flag" width="20" height="auto" />
                                            {{ option.label }}
                                          </template>
                                        </v-select>
                                      </CCol>
                                      <CCol sm="6" style="border: 1px solid #e5e5e5">
                                        <CInput
                                          type="text"
                                          name="numberPhone"
                                          id="numberPhone"
                                          addInputClasses="pr-2"
                                          maxlength="11"
                                          :value.sync="numberPhone"
                                          @keypress="isNumber($event)"
                                        />
                                      </CCol>
                                    </CRow>
                                    <CRow v-if="channelType[item.channel] == 'EMAIL'" sm="12" class="d-flex mt-3" :gutters="false">
                                      <CCol sm="12" style="border: 1px solid #e5e5e5">
                                        <CInput type="text" name="testEmail" id="testEmail" addInputClasses="pr-2" :value.sync="testEmail" />
                                      </CCol>
                                    </CRow>
                                  </div>
                                  <div class="confirmationDelete__footer">
                                    <div class="confirmationDelete__actions">
                                      <CButton
                                        class="confirmationDelete__btn btn btn-primary"
                                        :disabled="isLoadingSendContentTest"
                                        style="padding: 5px 20px"
                                        @click="sendContentTest(indexChannel, channelType[item.channel])"
                                      >
                                        <span class="mr-2">Send</span>
                                        <CSpinner
                                          v-if="isLoadingSendContentTest"
                                          class="c-spinner"
                                          color="custom-color"
                                          style="width: 1.1rem; height: 1.1rem"
                                        />
                                      </CButton>
                                      <CButton
                                        class="confirmationDelete__btn"
                                        @click="closeContentTest(indexChannel)"
                                        type="link"
                                        style="padding: 5px 20px"
                                      >
                                        {{ $t('campaign.campaignCreator.flow.text.cancel') }}</CButton
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </transition>
                        </template>
                      </template>

                      <template v-slot:footer>
                        <template v-if="i === 'audience' && prop.targetAudienceType">
                          <div class="p-3" style="border-top: 1px solid #d9e2ec">
                            <p class="text-box-campaign" v-if="prop.override">
                              {{ $t('campaign.campaignCreator.flow.text.override-unsubscribed') }}
                            </p>
                            <CSpinner v-if="isLoadingAudienceTotalContacts" class="border-right-primary mb-2" size="sm" />
                            <span v-else style="color: #7f889a; font-size: 21px">
                              {{ audienceTotalContacts[indexChannel] || '-' }}
                            </span>
                            <br />
                            <span style="color: #7f889a; font-size: 14px" class="text-uppercase p-2">
                              {{ $t('campaign.campaignCreator.flow.text.contacts') }}
                            </span>
                          </div>
                        </template>
                      </template>
                    </FlowCard>
                  </span>
                </template>
              </li>
              <li style="width: 256px" v-if="campaign.values.length <= 5 && campaign.status != 'READY_TO_SEND'" @click="addChannel = !addChannel">
                <a class="flowComponentPlus"></a>
                <div style class="headMainBox text-uppercase">
                  {{ $t('campaign.campaignCreator.flow.text.add-channel') }}
                </div>

                <div style="mainBox" v-if="addChannel">
                  <div class="bodyMainBox">
                    <addChannels />
                  </div>
                </div>
              </li>
            </ul>
          </li>
        </template>
      </ul>
    </nav>
    <center class="mt-5">
      <CSpinner class="mx-1" size="sm" v-if="loadingRocket" color="primary" />
      <CButton
        v-else
        color="primary"
        class="px-5 py-2 border"
        :disabled="campaign.status != 'READY_TO_SEND' && campaign.status != 'RUN'"
        @click="rocketControlStatus(campaignStatus)"
      >
        {{ rocketControl.text }}
      </CButton>
      <div
        class="mt-4 rocket text-uppercase"
        v-if="campaign.status == 'SETUP' || campaign.status == 'RUN'"
        @click="cancelCreateCampaign()"
        style="font-weight: normal; font-size: 11px; color: #a1a8b3; cursor: pointer"
      >
        <i class="fa fa-chevron-left" aria-hidden="true"></i>
        {{ $t('campaign.campaignCreator.flow.text.cancel') }}
      </div>
    </center>
  </div>
</template>

<script>
import MenssageAlert from '@/components/MenssageAlert'
import { DateTime } from 'luxon'
import FlowCard from './FlowCard'
import { CallingCodeMoreFlag } from '@/utils/countriesUtils.js'
import vSelect from 'vue-select'
import addChannels from '../addChannels'
import imageTemplate from '../imageTemplate'
import TextSimple from '../TextSimple'
import services from '@/services.js'
import { DYNAMIC_TEMPLATE_DESTINATION_TYPE } from '@/views/template/constants.js'
import { PLAN_TYPES } from '@/views/plansSubscriptions/constants'

export default {
  name: 'Flow',
  components: {
    FlowCard,
    vSelect,
    addChannels,
    imageTemplate,
    TextSimple,
    MenssageAlert,
  },

  props: {
    campaign: {
      type: Object,
    },
    campaignStatus: {
      type: Number,
    },
    campaignSummary: {
      type: Object,
    },
  },

  data() {
    return {
      messages: [],
      addChannel: false,
      indexChannelActive: '',
      contentTest: [false, false, false, false, false, false],
      numberPhone: '',
      testEmail: '',
      countrySelected: null,
      intervalId: null,
      loadingRocket: false,
      rocketControl: {
        className: 'setup',
        iconName: 'rocketSetup',
        classText: 'textSetup',
        text: 'SETUP',
      },
      isTestSent: [false, false, false, false, false, false],
      isTestSentMessage: '',
      // ? Tipo de canal -> quando for adicionado novos canais isso deve ser revisto
      channelType: {
        2: 'SMS',
        1: 'EMAIL',
      },
      DYNAMIC_TEMPLATE_DESTINATION_TYPE: DYNAMIC_TEMPLATE_DESTINATION_TYPE,
      audienceTotalContacts: [],
      isLoadingAudienceTotalContacts: false,
      isLoadingSendContentTest: false,
    }
  },
  async created() {
    this.campaign.values = []
  },
  async mounted() {
    this.$root.$on('push-block-Library', (value) => {
      this.indexChannelActive = value.indexChannel
    })

    this.rocketControlStatusMounted()
  },

  computed: {
    activeBlock() {
      return this.$store.state.campaign.activeBlock
    },

    optionsCountries() {
      return CallingCodeMoreFlag(this)
    },

    campaignStatusLabel() {
      if (this.campaignStatus == 3 || this.campaignStatus == 6) {
        // 1 = draft, 2 = calculating 3 = ready to send
        this.campaign.status = 'READY_TO_SEND'
      }
      return this.campaign.status
    },

    lang() {
      return this.$store.state.lang
    },

    isPlanFree() {
      return this.$store.state.auth.session.organization?.planType == PLAN_TYPES.FREE
    },
  },

  watch: {
    campaign: function () {
      this.getAllTotalContacts()
      if (this.campaign.values.length == 0) {
        this.backToSetup()
        return
      }
      let cp = this.campaign
      let flag = []
      for (let i = 0; i < cp.values.length; i++) {
        if (cp.values[i]) {
          if (
            cp.values[i].audience.targetAudienceType != '' &&
            cp.values[i].audience.totalContacts > 0 &&
            cp.values[i].content.senderId?.length &&
            // cp.values[i].content.displayName?.length &&
            // cp.values[i].content.emailPrefix?.length  &&
            (cp.values[i].content.content != '' || cp.values[i].content.templateId != null) &&
            (cp.values[i].time.targetTimeType == 'sendNow' || cp.values[i].time.targetTimeType == 'schedule')
          ) {
            flag[i] = true
            if (cp.values[i].content.templateName != null || cp.values[i].content.templateName != '') {
              if (cp.values[i].content.subject == '' || cp.values[i].content.displayName == '' || cp.values[i].content.emailPrefix == '') {
                flag[i] = false
              }
            }
          } else {
            flag[i] = false
          }
          // switch (cp.values[i].channel) {
          //   case '1': // ? EMAIL
          //     flag[i] = this.validacaoEmail(cp.values[i])
          //     break
          //   case '2': // ? SMS
          //     flag[i] = this.validacaoSMS(cp.values[i])
          //     break
          //   default:
          //     // ? CANAL NÃO PREVISTO
          //     flag[i] = false
          //     break
          // }
        }
      }
      if (!flag.includes(false)) {
        this.setRocketToRun()
      } else {
        this.backToSetup()
      }
    },
  },

  methods: {
    // Criado para solucionar a implementação ambigua criada antes
    async getAllTotalContacts() {
      this.audienceTotalContacts = await Promise.all(
        this.campaign.values.map((value) => {
          return this.getAudienceTotalContacts(value.audience.segments, value.channel, value.audience.override)
        }),
      )
    },
    async getAudienceTotalContacts(segments, channelType, override) {
      try {
        this.isLoadingAudienceTotalContacts = true
        const segmentsIds = segments.map((segment) => `segments=${segment.segmentId}`).join('&')
        let total = await services.getTotalAudience(this.$route.params.organizationId, channelType, segmentsIds, override)
        return total.data.data
      } finally {
        this.isLoadingAudienceTotalContacts = false
      }
    },
    validacaoSMS(item) {
      if (item.audience.targetAudienceType == '') return false
      if (item.audience.totalContacts == 0) return false
      if (item.content.senderId.length == '') return false
      if (item.content.content == '' || item.content.templateId == null) return false
      if (item.time.targetTimeType != 'sendNow' || item.time.targetTimeType != 'schedule') return false

      return true
    },

    validacaoEmail(item) {
      if (item.audience.targetAudienceType == '') return false
      if (item.audience.totalContacts == 0) return false
      if (item.content.senderId?.length == 0) return false
      if (item.content.displayName?.length == 0) return false
      if (item.content.emailPrefix?.length == 0) return false
      if (item.content.content == '' || item.content.templateId == null) return false
      if (item.time.targetTimeType != 'sendNow' || item.time.targetTimeType != 'schedule') return false

      if (item.content.templateName != null || item.content.templateName != '') {
        if (item.content.subject == '' && item.content.displayName == '' && item.content.emailPrefix == '') {
          return false
        }
      }

      return true
    },

    setRocketToRun() {
      if (this.campaign.status == 'SETUP') {
        this.$store.dispatch('campaign/changeStateRocket', 'RUN')
        this.rocketControl = {
          className: 'run',
          iconName: 'rocketRun',
          classText: 'textRun',
          text: this.$t('campaign.campaignCreator.flow.button.status.calculate'),
        }

        /*this.patchCampaign(
          this.$route.params.campaignId,
          this.campaign,
          this.campaign.name,
          "RUN"
        );*/
        return
      }
    },
    rocketControlStatus(campaignStatus) {
      if (campaignStatus == 6) return

      //SETUP, RUN, SENT_TO_BACKEND, READY_TO_SEND
      this.$store.commit('campaign/STOP_AUTOSAVE')

      if (this.campaign.status == 'RUN') {
        this.$store.dispatch('campaign/changeStateRocket', 'SENT_TO_BACKEND')
        /*this.rocketControl = {
          className: "send",
          iconName: "rocketSend",
          classText: "textSend",
          text: "SEND"
        };*/
        this.loadingRocket = true
        this.patchCampaign(this.$route.params.campaignId, this.campaign, this.campaign.name, 'SENT_TO_BACKEND')
        // this.clearStateFlow();
      } else if (this.campaign.status == 'READY_TO_SEND') {
        this.sendCampaign()
      }
      return
    },

    rocketControlStatusMounted() {
      if (this.campaign.status == 'SETUP') {
        this.rocketControl = {
          className: 'setup',
          iconName: 'rocketSetup',
          classText: 'textSetup',
          text: this.$t('campaign.campaignCreator.flow.button.status.setup'),
        }
        return
      }

      if (this.campaign.status == 'RUN') {
        this.rocketControl = {
          className: 'run',
          iconName: 'rocketRun',
          classText: 'textRun',
          text: this.$t('campaign.campaignCreator.flow.button.status.calculate'),
        }
        return
      }

      if (this.campaign.status == 'SENT_TO_BACKEND') {
        this.$router.push({
          name: 'loading',
        })
      }

      if (this.campaign.status == 'READY_TO_SEND') {
        this.rocketControl = {
          className: 'send',
          iconName: 'rocketSend',
          classText: 'textSend',
          text: this.$t('campaign.campaignCreator.flow.button.status.send'),
        }
        if (this.$router.name != 'campaignSend') {
          this.$router.push({
            name: 'campaignSend',
            params: { campaignId: this.$route.params.campaignId },
          })
        }
        return
      }
    },

    clearStateFlow() {
      this.$store.dispatch('campaign/setCurrentChannel', {
        blockLibrary: false,
        indexChannel: null,
        cardName: null,
        type: null,
        collapse: null,
      })
    },

    backToRun() {
      this.messages = []
      let campaignId = this.$route.params.campaignId
      let organizationId = this.$store.state.auth.organizationId

      services
        .cancelCampaign(organizationId, campaignId)
        .then((res) => {
          this.$router.push({ name: 'campaignCreator', params: { campaignId } })
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.title || response.data.message || 'Erro',
          })
        })
        .finally(() => {})
      /*
      this.$store.dispatch("campaign/changeStateRocket", "RUN");
      this.patchCampaign(
        this.$route.params.campaignId,
        this.campaign,
        this.campaign.name,
        "RUN"
      );*/

      return
    },

    backToCampaign() {
      this.$router.push({ name: 'campaignList' })
    },

    backToSetup() {
      this.$store.dispatch('campaign/changeStateRocket', 'SETUP')
      this.rocketControl = {
        className: 'setup',
        iconName: 'rocketSetup',
        classText: 'textSetup',
        text: this.$t('campaign.campaignCreator.flow.button.status.setup'),
      }

      /*this.patchCampaign(
          this.$route.params.campaignId,
          this.campaign,
          this.campaign.name,
          "SETUP"
        ); */

      return
    },

    patchCampaign(id, mainCampaign, name, status) {
      // this.$store.commit('campaign/STOP_AUTOSAVE')
      this.scrollTop(null)

      this.messages = []
      //.campaign.status = status;
      this.campaign.status = 'RUN' //APENAS PARA TESTAR O RUN SEM MUDAR O ESTADO
      let organizationId = this.$store.state.auth.organizationId
      services
        .patchCampaign(organizationId, id, { campaignWorkflow: { name: name, ...mainCampaign, lastUpdateDateTime: new Date() } })
        .then((response) => {
          const campaignWorkflow = response.data.data.campaignWorkflow
          this.campaignName = campaignWorkflow.name
          this.setMainCampaign(campaignWorkflow)

          const hasUpdateConflict = response.data.data.campaignUpdateConflictDetected
          if (hasUpdateConflict) {
            this.emitUpdateConflict()
          }

          //if(status == 'SENT_TO_BACKEND'){
          if (status == 'SENT_TO_BACKEND') {
            //APENAS PARA TESTAR O RUN SEM MUDAR O ESTADO
            // this.$router.push({ name: "loading" });
            this.runCampaign()
          } else {
            this.$router.push({
              name: 'campaignCreator',
              params: { campaignId: this.$route.params.campaignId },
            })
          }
        })
        .catch(({ response }) => {
          this.loadingRocket = false
          this.messages.push({
            status: 'danger',
            text: response.data.title || response.data.message || 'Erro',
          })
        })
        .finally(() => {})
    },

    runCampaign() {
      // this.$emit('setLoading')
      if (this.$route.params.campaignId) {
        let organizationId = this.$store.state.auth.organizationId
        services
          .patchRunCampaign(organizationId, this.$route.params.campaignId)
          .then(() => {
            this.$router.push({ name: 'campaignLoading', params: { campaignId: this.$route.params.campaignId } })
          })
          .catch(({ response }) => {
            this.loadingRocket = false
            this.messages.push({
              status: 'danger',
              text: response.data.title || response.data.message || 'Erro',
            })
          })
          .finally(() => {
            this.loadingRocket = false
            // this.$emit('setLoading', false)
          })
      }
    },

    sendCampaign() {
      this.$emit('setLoading')
      this.messages = []
      if (this.$route.params.campaignId) {
        let organizationId = this.$store.state.auth.organizationId
        services
          .patchSendCampaign(organizationId, this.$route.params.campaignId)
          .then((res) => {})
          .catch(({ response }) => {
            this.messages.push({
              status: 'danger',
              text: response.data.title || response.data.message || 'Erro',
            })
          })
          .finally(() => {
            this.$router.push({ name: 'campaignList' })
          })
      }
    },

    setMainCampaign(campaign) {
      this.$store.dispatch('campaign/setMainCampaign', campaign)
    },

    openBlock(obj) {
      this.$store.dispatch('campaign/collapse', obj)
    },

    formatDate(date) {
      var f = { month: 'long', day: 'numeric' }
      let dt = DateTime.fromISO(date)

      return dt.setLocale(this.lang).toLocaleString(f)
    },

    isCard(item) {
      if (Array.isArray(item) || typeof item === 'object') {
        return true
      }
      return false
    },

    isNumber(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // ! Tratament fora de padrão para atender a task ARP-978
    handlerTestMsg(data) {
      switch (data.errorCode + '') {
        case '100001':
          return this.$t('campaign.campaignCreator.flow.test.error.invalidEmail')
        case '130019':
          return this.$t('campaign.campaignCreator.flow.test.error.mobileOpartor')
        case '130020':
          return this.$t('campaign.campaignCreator.flow.test.error.invalidPhoneFormat')
        default:
          return data.message || 'Test error please try again'
      }
    },
    sendContentTest(index, channel) {
      this.isLoadingSendContentTest = true
      let campaignId = this.$route.params.campaignId

      if (channel == 'SMS') {
        let body = {
          recipientPhoneCountryIndicator: this.countrySelected.value,
          recipientMsisdn: this.numberPhone,
          senderId: this.campaign.values[index].content.senderId,
          senderName: this.campaign.values[index].content.senderName,
          smsMessage: this.campaign.values[index].content.content,
          templateId: this.campaign.values[index].content.templateId,
        }
        let organizationId = this.$store.state.auth.organizationId

        services
          .smsSchedulingTest(organizationId, body, campaignId)
          .then(() => {
            this.numberPhone = ''
            this.contentTest[index] = false
            this.isTestSent[index] = true
            this.isTestSentMessage = 'SMS test sent successfully'
            setTimeout(() => {
              this.isTestSent[index] = false
              this.isTestSentMessage = ''
            }, 5000)
          })
          .catch(({ response }) => {
            this.numberPhone = ''
            this.contentTest[index] = false
            this.isTestSent[index] = true
            this.isTestSentMessage = this.handlerTestMsg(response.data)
            setTimeout(() => {
              this.isTestSent[index] = false
              this.isTestSentMessage = ''
            }, 5000)
          })
          .finally(() => {
            this.isLoadingSendContentTest = false
          })
      } else if (channel == 'EMAIL') {
        let body = {
          from: this.campaign.values[index].content.emailPrefix + this.campaign.values[index].content.senderName,
          contentType: 2, // 1 = simples text || 2 = html
          displayName: this.campaign.values[index].content.displayName,
          recipientEmail: this.testEmail,
          replyTo: this.campaign.values[index].content.replyTo,
          subject: this.campaign.values[index].content.subject,
          templateId: this.campaign.values[index].content.templateId,
          timezone: null,
          senderId: this.campaign.values[index].content.senderId,
        }
        let organizationId = this.$store.state.auth.organizationId

        services
          .emailSchedulingTest(organizationId, body, campaignId)
          .then(() => {
            this.testEmail = ''
            this.contentTest[index] = false
            this.isTestSent[index] = true
            this.isTestSentMessage = 'EMAIL test sent successfully'
            setTimeout(() => {
              this.isTestSent[index] = false
              this.isTestSentMessage = ''
            }, 3000)
          })
          .catch(({ response }) => {
            this.testEmail = ''
            this.contentTest[index] = false
            this.isTestSent[index] = true
            this.isTestSentMessage = body.from == '' || null ? 'Error! Check your Sender and Display Name' : this.handlerTestMsg(response.data)
            setTimeout(() => {
              this.isTestSent[index] = false
              this.isTestSentMessage = ''
            }, 3000)
          })
          .finally(() => {
            this.isLoadingSendContentTest = false
          })
      }
    },

    closeContentTest(index) {
      this.contentTest[index] = false
      this.numberPhone = ''
      this.testEmail = ''
    },

    openContentTest(index) {
      this.contentTest[index] = true
      for (let i = 0; i < this.contentTest.length; i++) {
        if (i != index) {
          this.contentTest[i] = false
        }
      }
    },

    isCardClicked(card, indexChannel, activeBlockIndexChannel) {
      if (activeBlockIndexChannel == null) {
        return false
      } else {
        if (card == this.activeBlock.cardName && indexChannel == activeBlockIndexChannel) {
          return true
        } else {
          return false
        }
      }
    },

    cancelCreateCampaign() {
      this.messages = []
      let organizationId = this.$store.state.auth.organizationId

      services
        .deleteCampaign(organizationId, this.$route.params.campaignId)
        .then((res) => {
          this.$router.push({ name: 'campaignList' })
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.title || response.data.message || 'Erro',
          })
        })
        .finally(() => {})
    },

    attrByType: function (type) {
      switch (type) {
        case 'audience':
          return { minHeight: '200px', hasFooter: true }
        case 'content':
          return { minHeight: '170px', hasFooter: true }
        case 'time':
          return { minHeight: '140px', hasFooter: false }
        default:
          return { minHeight: '200px', hasFooter: true }
      }
    },

    pushChannel(indexChannel, cardName, channel) {
      this.scrollTop(cardName)
      this.$store.dispatch('campaign/setCurrentChannel', {
        blockLibrary: false,
        indexChannel: indexChannel,
        cardName: cardName,
        type: channel,
        collapse: cardName,
      })
    },

    removeChannel(indice) {
      let indexChannel = this.$store.state.campaign.activeBlock.indexChannel
      this.$store.dispatch('campaign/removeChannel', indice)

      //  fecha o blockLibrary caso o braço braço selecionado seja removido
      if (indexChannel && indexChannel == indice)
        this.$store.dispatch('campaign/setCurrentChannel', {
          blockLibrary: false,
          indexChannel: null,
          cardName: null,
          type: null,
          collapse: null,
        })
    },

    scrollTop: function (cardName) {
      if (cardName == 'content') {
        return
      }
      this.intervalId = setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.intervalId)
        }
        window.scroll(0, window.pageYOffset - 50)
      }, 20)
    },

    emitUpdateConflict() {
      this.$emit('update-conflicted')
    },
  },
}
</script>

<style scoped lang="scss" src="@/assets/scss/_flow.scss">
.flowWidth {
  width: 2000px !important;
}
</style>
<style lang="scss">
.v-select .vs__dropdown-toggle,
.select-country-code {
  height: 50px;
}
</style>
